import React from "react";

const SuccessIcon = () => {
  return (
    <svg
      id="Group_17503"
      data-name="Group 17503"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g
        id="Ellipse"
        fill="rgba(255,255,255,0.34)"
        stroke="#979797"
        stroke-width="1"
      >
        <circle cx="10" cy="10" r="10" stroke="none" />
        <circle cx="10" cy="10" r="9.5" fill="none" />
      </g>
      <path
        id="check"
        d="M31.675,28.859l-.428.414c-2.034,1.973-4.224,4.248-6.257,6.239L22,33.126l-.465-.371-.767.907.465.371,3.421,2.727.421.335.39-.377c2.158-2.094,4.506-4.552,6.64-6.622l.428-.414Z"
        transform="translate(-16.941 -22.682)"
        fill="none"
        stroke="none"
        stroke-width="1"
      />
    </svg>
  );
};
export default SuccessIcon;
